<template>
 <Breadcrumb :style="{margin: '16px 0'}">
  <BreadcrumbItem class="roadmapfamily" v-for="item in items" :key="item.key" :style="{fontSize:'14px',fontWeight:'normal',color:'#CB9728'}">{{item.value}}</BreadcrumbItem>
</Breadcrumb>
</template>


<script>

    export default {
        name:'RoadMap',
        //props:{list:Array},
        data () {
            return {
                items: [{
                    key:"",
                    value:""
                }]
            }
        },
        methods:{
            listen(map){
              this.items=map;
            },
            reset(){
                this.items=[]
            }
        }
    }
</script>
<style lang="scss" scoped>
.roadmapfamily{
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
</style>